import { render, staticRenderFns } from "./CardOther.vue?vue&type=template&id=7c742611&"
import script from "./CardOther.vue?vue&type=script&lang=js&"
export * from "./CardOther.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports